import { GenerateTestDataButton } from './GenerateTestDataButton';
import { generateCustomersTestData } from '../utils/customersTestDataGenerator';

export const GenerateCustomersButton = () => {
  return (
    <GenerateTestDataButton
      label="Generate Test Customers"
      generateFunction={generateCustomersTestData}
      queryKey={['customers']}
    />
  );
};